import { RootState } from "@/store/store";

const rootSelector = (state: RootState) => state.profile;

export const profileSelector = rootSelector